import ConsoleUI from "./Console.presenter";
import { useConsoleController } from "./useConsoleController";

// 비즈니스 로직은 useConsoleController(컨테이너)에 집약하고,
// UI에는 view/site/service/cash 도메인 그룹 단위로만 전달한다 (25개 개별 props → 4개 그룹).
const ConsoleContainer = () => {
  const { view, site, service, cash } = useConsoleController();
  return (
    <ConsoleUI view={view} site={site} service={service} cash={cash} />
  );
};

export default ConsoleContainer;
